"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable arrow-body-style */
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const withNavigation = (Component) => {
    return (props) => (React.createElement(Component, Object.assign({}, props, { routeParams: (0, react_router_dom_1.useParams)(), location: (0, react_router_dom_1.useLocation)(), navigation: {
            navigate: (0, react_router_dom_1.useNavigate)(),
        } })));
};
exports.default = withNavigation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2l0aE5hdmlnYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvd3JhcHBlcnMvd2l0aE5hdmlnYXRpb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEscUNBQXFDO0FBQ3JDLDZDQUErQjtBQUMvQix1REFBdUU7QUFFdkUsTUFBTSxjQUFjLEdBQUcsQ0FBQyxTQUFjLEVBQUUsRUFBRTtJQUN0QyxPQUFPLENBQUMsS0FBVSxFQUFPLEVBQUUsQ0FBQyxDQUN4QixvQkFBQyxTQUFTLG9CQUNGLEtBQUssSUFDVCxXQUFXLEVBQUUsSUFBQSw0QkFBUyxHQUFFLEVBQ3hCLFFBQVEsRUFBRSxJQUFBLDhCQUFXLEdBQUUsRUFDdkIsVUFBVSxFQUFFO1lBQ1IsUUFBUSxFQUFFLElBQUEsOEJBQVcsR0FBRTtTQUMxQixJQUNILENBQ0wsQ0FBQztBQUNOLENBQUMsQ0FBQztBQUVGLGtCQUFlLGNBQWMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludC1kaXNhYmxlIGFycm93LWJvZHktc3R5bGUgKi9cbmltcG9ydCAqIGFzIFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IHVzZUxvY2F0aW9uLCB1c2VOYXZpZ2F0ZSwgdXNlUGFyYW1zIH0gZnJvbSAncmVhY3Qtcm91dGVyLWRvbSc7XG5cbmNvbnN0IHdpdGhOYXZpZ2F0aW9uID0gKENvbXBvbmVudDogYW55KSA9PiB7XG4gICAgcmV0dXJuIChwcm9wczogYW55KTogYW55ID0+IChcbiAgICAgICAgPENvbXBvbmVudFxuICAgICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAgICAgcm91dGVQYXJhbXM9e3VzZVBhcmFtcygpfVxuICAgICAgICAgICAgbG9jYXRpb249e3VzZUxvY2F0aW9uKCl9XG4gICAgICAgICAgICBuYXZpZ2F0aW9uPXt7XG4gICAgICAgICAgICAgICAgbmF2aWdhdGU6IHVzZU5hdmlnYXRlKCksXG4gICAgICAgICAgICB9fVxuICAgICAgICAvPlxuICAgICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCB3aXRoTmF2aWdhdGlvbjtcbiJdfQ==